export default __webpack_public_path__ + "media/create-game3x.8aa21de3.png";